module.exports = __webpack_public_path__ + "static/media/cotton-bureau.a3496d89.svg";